import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";
import { Columns } from "./columns";

const SavedReportsConfig: ReportConfigBase = {
  type: EReportTypes.SavedReports,
  endpoint: "report-collection/get-report-by-identity",
  filtersBase: null,
  summaryBase: null,
  columnsBase: Columns,
  intro: { description: "", url: "" },
  hidePagination: true,
  reportKey: "reports",
  resultsPerPage: 9999,
};

export default SavedReportsConfig;
